<template>
    <div>
      <trademarkBulletinAnalyseReport-list></trademarkBulletinAnalyseReport-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  